import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  	isAuthorized: false,
  	token: '',
	  user: {},
    userMeta: {},
    vpnCredentials: [],
    paymentHistory: [],
    signupSteps: 4,
    signupStep: 0,
    signupProcessing: false,
    errorLogin: false,
    registrationUser: {},
    userPreferences: [],
    design: {
      mainAccentColor: '#ee4540'
    }
  },
  mutations: {
    setSignupStep (state, data) {
      state.signupStep = data;
    },
    fillUserMeta (state, data) {
      state.userMeta = data;
    },
    fillRegistration (state, data) {
      state.registrationUser = data;
    },
    toggleLoginInvalid (state) {
      state.errorLogin = true;
    },
    flushSignUpStep (state) {
      state.signupStep = 0;
    },
    nextSignUp (state) {
      state.signupProcessing = true;
      state.signupStep = ( (state.signupStep + 1) == state.signupSteps ) ? 0 : (state.signupStep + 1);
      state.signupProcessing = false
    },
    prevSignUp (state) {
      state.signupProcessing = true;
      state.signupStep = ( (state.signupStep - 1) < 0 ) ? 0 : (state.signupStep - 1);
      state.signupProcessing = false
    },
  	storeUserToken (state, data) {
  		state.token = data;
  	},
  	makeUserAuthorized (state, data) {
      // добавить тут редирект
  		state.isAuthorized = true;
  		state.user = data.user;
  	},
  	makeUserDeauthorized (state) {
  		state.isAuthorized = false;
  		state.user = {}
  		state.token = ''
  	},
    fillPaymentHistory (state, data) {
      state.paymentHistory = data
    },
    fillVPNCredendtials (state, data) {
      state.vpnCredentials = data
    },
    fillUserPreferences (state, data) {
      state.userPreferences = data
    }
  },
  getters: {
    vpnUser: state => {
      return state.vpnCredentials && state.vpnCredentials[0] && state.vpnCredentials[0].vpnUsername
    },
    vpnPass: state => {
      return state.vpnCredentials && state.vpnCredentials[0] && state.vpnCredentials[0].vpnPassword
    },
    securityPrompt: state => {
      return state.userPreferences && state.userPreferences[0] && state.userPreferences[0].security_prompt
    },
    accentColor: state => {
      return state.design.mainAccentColor
    },
    getRegistrant: state => {
      return state.registrationUser
    },
    getToken: state => {
      return state.token
    },
    getAuthState: state => {
      return state.token.length > 0
    },
    getUser: state => {
      return state.user
    },
    defaultAuthProvider: state => {
      return state.user && state.user.providerData && state.user.providerData[0] && state.user.providerData[0].providerId
    },
    listAuthProviders: state => {
      return state.user && state.user.providerData
    }
  },
  actions: {
    updateRegistrationInfo (context, payload) {
      context.commit('fillRegistration', payload)
    },
    makeAuthInvalid (context) {
      context.commit('toggleLoginInvalid')
    },
    addSignup (context) {
      context.commit('nextSignUp')
    },
    subSignup (context) {
      context.commit('prevSignUp')
    },
    initSignup (context) {
      context.commit('flushSignUpStep');
    },
    setToken: async (context, payload) => {
      firebase.auth().currentUser.getIdToken().then( (idt) => {
          context.commit('makeUserAuthorized', payload);
          context.commit('storeUserToken', idt);
      });
    },
    setUserMeta: async (context) => {
      const snapshot = await firebase.firestore().collection('users').doc(context.state.user.email).get()
      context.commit('fillUserMeta', snapshot.data());
    },
    setPaymentHistory: async (context) => {
      const snapshot = await firebase.firestore().collection('users').doc(context.state.user.email).collection('transactions').get()
      context.commit('fillPaymentHistory', snapshot.docs.map(doc => doc.data()));
    },
    setVPNDetails: async (context) => {
      const snapshot = await firebase.firestore().collection('users').doc(context.state.user.email).collection('grants').get()
      context.commit('fillVPNCredendtials', snapshot.docs.map(doc => doc.data()));
    },
    setUserPreferences: async (context) => {
      const snapshot = await firebase.firestore().collection('users').doc(context.state.user.email).collection('preferences').get()
      context.commit('fillUserPreferences', snapshot.docs.map(doc => doc.data()));
    }
  },
  plugins: [createPersistedState({
      paths: ['isAuthorized', 'isLoggedIn', 'user', 'token', 'vpnCredentials', 'paymentHistory']
    })]
})
